import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Run"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M19.5 3H4.5C3.67157 3 3 3.67157 3 4.5V19.5C3 20.3284 3.67157 21 4.5 21H7.5V19.5H4.5V9H21V4.5C21 3.67157 20.3284 3 19.5 3ZM4.5 7.5V4.5H19.5V7.5H4.5ZM20.25 16.5C20.25 14.0147 18.2353 12 15.75 12C13.2647 12 11.25 14.0147 11.25 16.5C11.25 18.9853 13.2647 21 15.75 21C18.2353 21 20.25 18.9853 20.25 16.5ZM14.25 18.75L18 16.5L14.25 14.25V18.75ZM9.75 16.5C9.75 13.1863 12.4363 10.5 15.75 10.5C19.0637 10.5 21.75 13.1863 21.75 16.5C21.75 19.8137 19.0637 22.5 15.75 22.5C12.4363 22.5 9.75 19.8137 9.75 16.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Run.vue"]]);
